<template>
  <div>

    <v-dialog v-model="showSlides[1]" width="450">
      <v-card>
        <v-card-title>
          <div class="headline">
            Welcome to {{ gameDisplayedName }}
          </div>
        </v-card-title>
        <v-card-text>
          <img :src="imageUrl" height="150px">
          <div v-html="gameIntroText"></div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="geogaming-dark-blue uia-tutorial-slide1-playNowBtn" flat="flat" @click.native="showSlide(0)">
            Play now!
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="geogaming-dark-blue" flat="flat" @click.native="showSlide(2)">
            Watch tutorial
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSlides[2]" width="450">
      <tutorial-gif-card
        title="See all challenges on the map"
        gif-path="/static/img/tutorial/map-screen.3142a5863580f8fbd5b5.gif"
        @previous="showSlide(1)"
        @next="showSlide(3)"
      ></tutorial-gif-card>
    </v-dialog>

    <v-dialog v-model="showSlides[3]" width="450">
      <tutorial-gif-card
        title="Go to a challenge to unlock it"
        gif-path="/static/img/tutorial/challenge-unlocked.4e2d1d451ef931fac236.gif"
        @previous="showSlide(2)"
        @next="showSlide(4)"
      ></tutorial-gif-card>
    </v-dialog>

    <v-dialog v-model="showSlides[4]" width="450">
      <tutorial-gif-card
        title="Solve it and win points!"
        gif-path="/static/img/tutorial/challenge-solved.869f18c5b0bd3034b738.gif"
        @previous="showSlide(3)"
        @next="showSlide(5)"
      ></tutorial-gif-card>
    </v-dialog>

    <v-dialog v-model="showSlides[5]" width="450">
      <tutorial-gif-card
        title="Bonus if you are fast and right!"
        gif-path="/static/img/tutorial/challenge-bonus.9349890e6db4125d45da.gif"
        @previous="showSlide(4)"
        @next="showSlide(6)"
      ></tutorial-gif-card>
    </v-dialog>

    <v-dialog v-model="showSlides[6]" width="450">
      <tutorial-gif-card
        title="Check who’s winning in real time"
        gif-path="/static/img/tutorial/leaderboard-teams.jk3kj23j434kp320bn3.gif"
        @previous="showSlide(5)"
        @next="showSlide(7)"
      ></tutorial-gif-card>
    </v-dialog>

    <v-dialog v-model="showSlides[7]" width="450">
      <tutorial-gif-card
        title="See your pictures in the gallery"
        gif-path="/static/img/tutorial/photos-gallery.4kjdfure398dsh213.gif"
        @previous="showSlide(6)"
        @next="showSlide(8)"
      ></tutorial-gif-card>
    </v-dialog>

    <v-dialog v-model="showSlides[7]" width="450">
      <v-card>
        <v-card-title>
          <div class="headline">
            That’s it!
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn class="geogaming-dark-blue" flat="flat" @click.native="showSlide(5)">
            Previous
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="geogaming-dark-blue" flat="flat" @click.native="showSlide()">
            Play now!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  import _ from 'lodash'
  import TutorialGifCard from '@/components/single/TutorialGifCard'

  import selected from '../../geogaming-selected'
  import config from '../../geogaming-config'

  const DEFAULT_CONFIG_NAME = 'default'
  const configName = selected.envName
  console.log(' > stage:' + configName)

  const DEFAULT_TITLE = config[configName] ? config[configName].title : config[DEFAULT_CONFIG_NAME].title
  const DEFAULT_IMAGE_URL = config[configName] ? config[configName].logo : config[DEFAULT_CONFIG_NAME].logo

  export default {
    name: 'tutorial-dialog',
    components: {
      TutorialGifCard,
    },
    props: {
      game: null,
    },
    data() {
      return {
        showSlides: [null, false, false, false, false, false, false],
        unwatchHandler: null,
      }
    },
    mounted() {
      const localStorage = window && window.localStorage
      if ((localStorage && !localStorage.getItem('tutorialShowedOnce')) || this.$store.state.launchTutorial === true) {
        this.showSlide(1)
        localStorage.setItem('tutorialShowedOnce', 'true')
        this.$store.commit('IS_TUTORIAL_IN_PROGRESS', true)
      }

      // For tests, display it all the time
      // this.showSlide(1)

      this.unwatchHandler = this.$store.watch((state) => state.launchTutorial, (newLaunchTutorialValue) => {
        if (newLaunchTutorialValue === true) {
          this.showSlide(1)
        }
      })
    },
    destroyed() {
      if (this.unwatched !== null) {
        this.unwatchHandler()
      }
    },
    computed: {
      imageUrl: function () {
        if (this.game) {
          return this.game.imageUrl ? this.game.imageUrl : _.get(this.$store.state.tenant, 'logoUrl', DEFAULT_IMAGE_URL)
        } else {
          return _.get(this.$store.state.tenant, 'logoUrl', DEFAULT_IMAGE_URL)
        }
      },
      gameDisplayedName: function () {
        if (this.game) {
          return this.game.gameDisplayedName ? this.game.gameDisplayedName : _.get(this.$store.state.tenant, 'title', DEFAULT_TITLE)
        } else {
          return _.get(this.$store.state.tenant, 'title', DEFAULT_TITLE)
        }
      },
      gameIntroText: function () {
        return _.get(this.$store.state.tenant, 'introText', config[configName].introText ? config[configName].introText : config[DEFAULT_CONFIG_NAME].introText)
      },
    },
    methods: {
      showSlide(slideIndex) {
        this.$store.commit('LAUNCH_TUTORIAL', false)
        const newShow = [null, false, false, false, false, false, false]
        setTimeout(() => {
          if (slideIndex) {
            newShow[slideIndex] = true
          }
          this.showSlides = newShow
        })
      },
    },
    watch: {
      showSlides: function (showSlides) {
        const hideSlidesState = [null, false, false, false, false, false, false]
        if (_.isEqual(showSlides, hideSlidesState)) {
          this.$store.commit('IS_TUTORIAL_IN_PROGRESS', false)
        }
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  @import '../../assets/styles/colors.scss';

  .geogaming-dark-blue {
    color: $geogaming-dark-blue-color;
  }

  .card {
    .card__title {
      text-align: center;

      .headline {
        width: 100%;
        font-size: 20px !important;
        color: $geogaming-dark-blue-color;
        font-weight: bold;
      }
    }

    .with-nav {
      display: flex;
      align-items: center;
      padding-bottom: 40px;

      .flex-grow {
        flex: 1;
      }
    }

    .card__text {
      text-align: center;

      .winner {
        color: #0E2356;
        font-weight: bold;
        font-size: 140%;
        margin-bottom: 0;
        margin-top: 0;
      }

      .prize {
        margin-top: 5px;
        color: #0E2356;
      }

      p {
        font-size: 16px;
      }

      a {
        text-decoration: none;

        .icon {
          margin-right: 5px;
        }
      }

      .btn-nav {
        min-width: 40px;
        margin: 0;

        &.geogaming-dark-blue {
          background-color: $geogaming-dark-blue-color;

          .icon {
            color: white;
          }
        }
      }
    }

    .card__actions {
      .geogaming-dark-blue {
        color: $geogaming-dark-blue-color;
        font-weight: bold;
      }

    }
  }

  .prizes {
    .winner img {
      margin-right: 3px;
    }

    .winner.overall img {
      width: 14px;
    }

    .winner.top15 img {
      width: 20px;
    }

    .winner.weekly img {
      width: 30px;
    }

    .winner.all img {
      width: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/single/TutorialDialog.vue